import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent';

export const SpaceOverviewRoute = getSpaceOverviewRoute(SpaceOverviewRouteComponent);
